var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.mobile)?_c('ComposedDropdownAssetBalances',{attrs:{"balances":_setup.balances}}):_c('ComposedListMultipleAssetAmounts',{staticClass:"flex-nowrap desktop-balances",attrs:{"balances":_setup.balances}})
}
var staticRenderFns = []

export { render, staticRenderFns }